import { PageInfo } from 'syf-js-utilities/typings/analytics'

declare global {
  interface SFDDL {
    pageInfo?: PageInfo
    apptimize?: {
      subject: string
      [key: string]: boolean | string // refer useApptimize.ts for details on what is stored in _SFDDL.apptimize
    }
    [key: string]: unknown
  }
  interface Window {
    QSI: {
      API: {
        load: () => void
        run: () => void
        unload: () => void
      }
    }
    _SFDDL: SFDDL
  }
}

const triggerQualtrics = (): void => {
  window.QSI?.API?.unload()
  window.QSI?.API?.load()
  window.QSI?.API?.run()
}

export default triggerQualtrics
